"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const button_1 = __importDefault(require("components/cosmos/button/button"));
const Input_1 = __importDefault(require("components/cosmos/Input"));
const InputLabel_1 = __importDefault(require("components/cosmos/InputLabel"));
const modal_1 = require("components/cosmos/v2/modal");
const translate_1 = require("components/translate");
const aiContent_1 = require("modules/app/services/datahub/aiContent");
const AIContentContext_1 = require("./AIContentContext");
const ContentForm = ({ onNextStep, t }) => {
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const { subject, setSubject } = (0, AIContentContext_1.useAIContentContext)();
    const handleChange = (event) => {
        setSubject(event.target.value);
    };
    const handleClick = () => {
        setIsLoading(true);
        onNextStep();
        aiContent_1.DatahubAIContentService.sendGenerateStructure(subject);
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(modal_1.Modal.Header, { children: (0, jsx_runtime_1.jsx)("h2", { className: "_text-4 _font-weight-bold _mb-0", children: t('ai_content_structure.step_01.title') }) }), (0, jsx_runtime_1.jsxs)(modal_1.Modal.Body, { children: [(0, jsx_runtime_1.jsx)(InputLabel_1.default, { htmlFor: "subject", className: "_mt-0", children: t('ai_content_structure.step_01.search_field.label') }), (0, jsx_runtime_1.jsxs)("div", { className: "_d-flex", children: [(0, jsx_runtime_1.jsx)(Input_1.default, { id: "subject", "aria-label": "", placeholder: t('ai_content_structure.step_01.search_field.placeholder'), className: "_mr-3", value: subject, onChange: handleChange }), (0, jsx_runtime_1.jsx)(button_1.default, { variation: "primary", disabled: subject === '', loading: isLoading, onClick: handleClick, children: t('ai_content_structure.step_01.generate_structure') })] })] })] }));
};
exports.default = (0, translate_1.translate)()(ContentForm);
